<template lang="pug">
#PredictionNickname
    //- Header Global
    .change-on-mobile
        button.mobile-only.overlay-button(
            v-on:click="toggleSidebar()"
        )
            .btn-change-menu
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
        HeaderGlobal(HeaderGlobalHeading="Prediction Nickname" :HeaderGlobalBreadcrumb="breadcrumb")

    .box
        .box__header.no-border
            header.flex.items-center.justify-between
                .header-meta
                    h2.subheading List Prediction
                .header-cta.flex.items-center
                    button.btn-primary.mr-2(
                        v-on:click="phonebookGrid = !phonebookGrid"
                    )
                        template(v-if="phonebookGrid == false")
                            i.icon-btn.mr-1
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                            span View as grid
                        template(v-else)
                            i.icon-btn.mr-1
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                            span View as list
        .box__body.p-4
            template(v-if="load_data_status_get_contact.status === 'loading'")
                Loading(show="true")

            template(v-else)
                template(v-if="get_contact && Object.keys(get_contact).length > 0")
                    .flex.flex-wrap.boxed-alphabet.-mx-4
                        .alphabet.p-4
                            .alphabet__header
                                //- strong Possible Nickname : {{possibleNickname}}
                                strong.text-light Possible Nickname
                            .alphabet__body
                                template(v-if="get_contact.prediction_name !== undefined && get_contact.prediction_name.length > 0")
                                    ul(v-for="name in get_contact.prediction_name")
                                        li.block.mb-3(v-tooltip="name && name.length > 30? name : ''")
                                            | {{ name?(name.length > 30 ? name.substr(0, 30)+'...' : name) : '-' }}
                                template(v-else-if="possibleNickname !== undefined && possibleNickname.length > 0")
                                    ul(v-for="name in possibleNickname")
                                        li.block.mb-3(v-tooltip="name && name.length > 30? name : ''")
                                            | {{ name?(name.length > 30 ? name.substr(0, 30)+'...' : name) : '-' }}
                                template(v-else)
                                    span {{get_contact.displayName?get_contact.displayName:'-'}}
                    .flex.flex-wrap.boxed-alphabet.-mx-4(v-bind:class="{'boxed-alphabet--list': !phonebookGrid }")
                        template(v-for="letter in letters")
                            .alphabet.p-4
                                .alphabet__header
                                    strong.text-light {{letter}}
                                .alphabet__body
                                    template(v-if="groupedContacts[letter] !== undefined")
                                        ul(v-for="name in groupedContacts[letter]")
                                            li.block.mb-3(v-tooltip="name && name.length > 30? name : ''")
                                                | {{ name?(name.length > 30 ? name.substr(0, 30)+'...' : name) : '-' }}
                                    template(v-else)
                                        span -
                NoDataAvailable(v-else)

</template>

<script>
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'PredictionNickname',
    components: {
        HeaderGlobal,
        Loading,
        NoDataAvailable,
    },
    props: ['resultGlobalBreadcrumb'],
    data() {
        return {
            phonebookGrid : true,
            breadcrumb: [
                this.resultGlobalBreadcrumb,
                {
                    name: 'Prediction Nickname',
                    url: '/result/prediction-nickname',
                },
            ],
            // dataPredictionNickname: {},
        };
    },
    computed: {
        ...mapState([
            'load_data_status_get_contact',
            'get_contact',
        ]),
        letters() {
            let letters = []
            for(let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++) {letters.push(String.fromCharCode([i]))}
            return letters
        },
        possibleNickname(){
            // console.log('hmmmmm')
            if (this.get_contact && this.get_contact.tags != undefined && this.get_contact.tags.length > 0) {
                // console.log('this.get_contact.tags')
                // console.log(this.get_contact.tags)
                var inputNickname = this.inputNickname(this.get_contact.tags)
                var sortByFrequency = this.sortByFrequency(inputNickname)
                // console.log('sortByFrequency')
                // console.log(sortByFrequency)
                var getTop3Nickname = this.getTop3Nickname(sortByFrequency[0], this.get_contact.tags)
                return getTop3Nickname
            } else {
                return []
            }
        },
        groupedContacts: function() {
            if (Object.keys(this.get_contact).length > 0) {
                var groups = {};
                //Loops every contact
                var tags = this.get_contact.tags
                tags.forEach(function(contact) {
                    //Gets the contact's first char in the contact's name
                    var firstLetter = contact.charAt(0);
                    //Checks if the 'groups' object contains the key for the contact's first letter
                    if (!groups[firstLetter]) {
                        //If it doesn't, creates it as an empty array.
                        groups[firstLetter] = [];
                    }

                    var entry = groups[firstLetter];
                    //Adds the contact to the group
                    entry.push(contact);
                });
                // this.dataPredictionNickname = groups;
                return groups;
            } else {
                return {};
            }
        }
    },
    watch: {
        // get_contact(newData) {
        //     if (Object.keys(newData).length > 0) {
        //         var groups = {};
        //         //Loops every contact
        //         var tags = this.get_contact.tags
        //         tags.forEach(function(contact) {
        //             //Gets the contact's first char in the contact's name
        //             var firstLetter = contact.charAt(0);
        //             //Checks if the 'groups' object contains the key for the contact's first letter
        //             if (!groups[firstLetter]) {
        //                 //If it doesn't, creates it as an empty array.
        //                 groups[firstLetter] = [];
        //             }

        //             var entry = groups[firstLetter];
        //             //Adds the contact to the group
        //             entry.push(contact);
        //         });
        //         this.dataPredictionNickname = groups;
        //     }
        // },
    },
    methods: {
        toggleSidebar() {
            EventEmit.$emit('toggleSidebar')
        },
        inputNickname(array) {
            var tmpArray = []
            for (var i = 0; i < array.length; i++) {
                var split = array[i].split(' ')
                // console.log('split')
                // console.log(split)
                // console.log('tmpArray')
                // console.log(tmpArray)
                tmpArray = tmpArray.concat(split)
                // console.log('tmpArray after')
                // console.log(tmpArray)
            }
            // console.log('tmpArray')
            // console.log(tmpArray)
            return tmpArray
        },
        sortByFrequency(array) {
            // console.log('array')
            // console.log(array)
            // var frequency = {};

            // array.forEach(function(value) { frequency[value] = 0; });

            // var uniques = array.filter(function(value) {
            //     return ++frequency[value] == 1;
            // });

            // return uniques.sort(function(a, b) {
            //     return frequency[b] - frequency[a];
            // });
            var frequency = {}, value;

            // compute frequencies of each value
            for(var i = 0; i < array.length; i++) {
                value = array[i];
                if(value in frequency) {
                    frequency[value]++;
                }
                else {
                    frequency[value] = 1;
                }
            }

            // make array from the frequency object to de-duplicate
            var uniques = [];
            for(value in frequency) {
                uniques.push(value);
            }

            // sort the uniques array in descending order by frequency
            function compareFrequency(a, b) {
                return frequency[b] - frequency[a];
            }

            return uniques.sort(compareFrequency);
        },
        getTop3Nickname(key, array){
            var tmpArray = []
            for (var i = 0; i < array.length; i++) {
                if (tmpArray.length === 3) {
                    break;
                }
                if(array[i].includes(key)){
                    tmpArray.push(array[i])
                }
            }
            return tmpArray
        },
    },
    mounted() {
    },
}
</script>

<style lang="sass">
    .boxed-alphabet
        .alphabet
            width: 25%
            &__header
                border-bottom-width: 1px
                border-style: solid
                padding-bottom: 1em
                margin-bottom: 1em
        &--list
            .alphabet
                width: 100%
</style>
